export const DEFAULT_PADDING = 32
export const DEFAULT_DECIMALS = 6 // USDC
export const DEFAULT_DESTINATION_DOMAIN = 1 // AVAX
export const DEFAULT_MIN_FINALITY_THRESHOLD = 2000
